import { textSizes, TextProps } from './types';

export const getHeadlineFontSize = ({ size }: TextProps) => {
  switch (size) {
    case textSizes.BIG:
      return '24px';
    case textSizes.REGULAR:
      return '20px';
    case textSizes.SMALL:
      return '16px';
    default:
      return '20px';
  }
};

export const getSubtitleFontSize = ({ size }: TextProps) => {
  switch (size) {
    case textSizes.BIG:
      return '16px';
    case textSizes.REGULAR:
      return '14px';
    case textSizes.SMALL:
      return '12px';
    default:
      return '14px';
  }
};

export const getBodyTextFontSize = ({ size }: TextProps) => {
  switch (size) {
    case textSizes.BIG:
      return '16px';
    case textSizes.REGULAR:
      return '14px';
    case textSizes.SMALL:
      return '12px';
    default:
      return '14px';
  }
};
